module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/82f037fef9adc6a092b7c25801e46510.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_activity_points.svg
// module id = dsjG
// module chunks = 1